import { Icon, RadioProps } from "@mui/material";
import { Theme } from "@mui/material/styles";
import ICONS from "../../assets/icons";
//

// ----------------------------------------------------------------------

export default function Radio(theme: Theme) {
  return {
    MuiRadio: {
      defaultProps: {
        icon: <Icon>{ICONS.radio}</Icon>,
        checkedIcon: <Icon>{ICONS.checkedRadio}</Icon>,
      },

      styleOverrides: {
        root: ({ ownerState }: { ownerState: RadioProps }) => ({
          padding: theme.spacing(1),
          ...(ownerState.size === "small" && {
            "& svg": { width: 20, height: 20 },
          }),
          ...(ownerState.size === "medium" && {
            "& svg": { width: 24, height: 24 },
          }),
        }),
      },
    },
  };
}
